<template>
  <div class="teaching-arrange-setting-configure-custom"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="defaults">
      <div class="header theme-light-bg theme-text">
        <div class="label">{{site.name}} - 配置信息</div>
      </div>
      <div class="body">
        <div class="body-cont"
             v-loading="committing"
             element-loading-text="数据提交中，请稍等...">
          <AppScrollbar style="height: 100%">
            <div class="configure-main">
              <div class="config-item">
                <div class="label">
                  <TitleGroup title="上课时段说明"
                              :bold="false">
                    <template #extra>
                      <el-button size="mini"
                                 type="text"
                                 :disabled="useDefault.period"
                                 @click="setUseDefault('period')">使用默认配置</el-button>
                    </template>
                  </TitleGroup>
                </div>
                <div class="value">
                  <TeachingArrangeSettingDefault v-model="useDefault.period">
                    <TeachingArrangeSettingPeriod ref="period"
                                                  :periods="getPeriods"></TeachingArrangeSettingPeriod>
                  </TeachingArrangeSettingDefault>
                </div>
              </div>
              <div class="config-item">
                <div class="label">
                  <TitleGroup title="设置成绩比例（同一课程类别下，各比例总和需为100%）"
                              :bold="false">
                    <template #extra>
                      <el-button size="mini"
                                 type="text"
                                 :disabled="useDefault.scale"
                                 @click="setUseDefault('scale')">使用默认配置</el-button>
                    </template>
                  </TitleGroup>
                </div>
                <div class="value">
                  <TeachingArrangeSettingDefault v-model="useDefault.scale">
                    <TeachingArrangeSettingScale ref="scale"
                                                 :scales="getScales"></TeachingArrangeSettingScale>
                  </TeachingArrangeSettingDefault>
                </div>
              </div>
            </div>
          </AppScrollbar>
        </div>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="primary"
                   :disabled="committing"
                   @click="handleApply">保存设置</el-button>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>配置信息加载失败</div>
        <el-button type="text"
                   @click="loadDefaults">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import TitleGroup from '../../../../../../../widgets/custom/TitleGroup'
import TeachingArrangeSettingDefault from '../widget/default'
import TeachingArrangeSettingPeriod from '../widget/period'
import TeachingArrangeSettingScale from '../widget/scale'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'TeachingArrangeSettingConfigureCustom',
  components: {
    AppScrollbar,
    TitleGroup,
    TeachingArrangeSettingDefault,
    TeachingArrangeSettingPeriod,
    TeachingArrangeSettingScale,
    Hint
  },
  props: {
    site: {
      type: Object,
      required: true
    },
    lessonPeriods: Array,
    courseTypes: Array
  },
  data () {
    return {
      loading: false,
      defaults: null,
      useDefault: {
        period: true,
        scale: true
      },
      committing: false
    }
  },
  computed: {
    getPeriods () {
      const defaults = this.defaults
      if (defaults) {
        let getPeriods = defaults.periods || []
        const lessonPeriods = this.lessonPeriods
        if (lessonPeriods) {
          return lessonPeriods.map(item => {
            let value = getPeriods.find(v => v.type === item.code)
            return this.$extend(item, value)
          })
        }
      }
    },
    getScales () {
      const defaults = this.defaults
      if (defaults) {
        let getScales = defaults.scales || []
        const courseTypes = this.courseTypes
        if (courseTypes) {
          return courseTypes.map(item => {
            let value = getScales.find(v => v.courseTypeId === item.id)
            return this.$extend(item, value)
          })
        }
      }
    }
  },
  methods: {
    loadDefaults () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/setting/arrange/site/defaults',
        method: 'post',
        data: this.$qs.stringify({
          siteId: this.site.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.defaults = response.data['defaults'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    setUseDefault (configType) {
      this.$set(this.useDefault, configType, true)
    },
    handleApply () {
      let validates = []
      let period = this.$refs.period
      if (period) {
        validates.push(this.useDefault.period ? Promise.resolve([]) : period.validate())
      }
      let scale = this.$refs.scale
      if (scale) {
        validates.push(this.useDefault.scale ? Promise.resolve([]) : scale.validate())
      }
      if (validates.length) {
        Promise.all(validates).then(([periods, scales]) => {
          this.committing = true
          this.$ajax({
            url: '/workspace/manager/teaching/setting/arrange/site/submitDefaults',
            method: 'post',
            data: this.$qs.stringify({
              siteId: this.site.id,
              settingInfo: JSON.stringify({periods, scales})
            })
          }).then(response => {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$nextTick(() => {
                  this.$emit('configure-change', this.site.id, response.data.configured)
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          }).finally(() => {
            this.committing = false
          })
        }, err => {
          this.$message.warning(err.message)
        })
      }
    }
  },
  mounted () {
    this.loadDefaults()
  },
  watch: {
    defaults (val) {
      if (val) {
        this.$nextTick(() => {
          this.useDefault.period = !val.periods || !val.periods.length
          this.useDefault.scale = !val.scales || !val.scales.length
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../styles/color";
  .teaching-arrange-setting-configure-custom {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      position: relative;
      border-bottom: 1px solid #ebeef5;
      & > .label {
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        padding: 9px 15px;
      }
    }
    & > .body {
      flex: auto;
      position: relative;
      & > .body-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .configure-main {
          padding: 30px 15px;
          & > .config-item {
            max-width: 100%;
            margin: auto;
            width: 720px;
            & > .label {
              .title-group {
                & > .header {
                  & > .extra {
                    .el-button {
                      padding: 0;
                    }
                  }
                }
              }
            }
            & > .value {
              margin-top: 10px;
            }
            & + .config-item {
              margin-top: 30px;
            }
          }
        }
      }
    }
    & > .footer {
      flex: none;
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
